import { FC } from 'react';
import {ProductThumb} from '../../../components/common/ProductThumb';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { ITransactionReportModel } from '../core/_models';
import {storeCurrencyLabel} from '../../common/currencyLabel'

type IProps = {
    item: ITransactionReportModel;
    showDetails: (params?: ITransactionReportModel) => void;
};

const TransactionReportTableRow: FC<IProps> = ({ item, showDetails }) => {
    const { formatMessage } = useIntl();

    return (
        <tr>
            <th>
                {item.type === 'pickup_fees' ? null : (
                    <ProductThumb src={item.image} className="table-img" alt="Product"/>
                )}
            </th>
            {/* Multi-supplier (T4): link product transactions to the
                supplier's own offer (pickup-fee rows have no product). */}
            <td>
                {item.barcode && item.type !== 'pickup_fees' ? (
                    <Link to={`/offers/list?search=${encodeURIComponent(String(item.barcode))}`} title={formatMessage({id: 'reports.view_my_offer'})}>
                        {item.barcode}
                    </Link>
                ) : (item.barcode || '-')}
            </td>
            <td>{item.model || '-'}</td>
            <td>{item.name || '-'}</td>
            <td>{item.transaction_type || '-'}</td>
            <td>{item.transaction_date	 || '-'}</td>
            <td>{item.adjusted_quantity || '-'}</td>
            <td>
                {item.sale_price && item.sale_price !== '-' ? (
                    <>
                        {item.sale_price} {storeCurrencyLabel(formatMessage)}
                    </>
                ) : '-'}
            </td>
            <td>
                {item.total_sale_price && item.total_sale_price !== '-' ? (
                    <>
                        {item.total_sale_price} {storeCurrencyLabel(formatMessage)}
                    </>
                ) : '-'}
            </td>
            <td>{item.dumyah_fees || '0'} {storeCurrencyLabel(formatMessage)}</td>
            <td style={{color: item.color }}>{item.net || '-'} {storeCurrencyLabel(formatMessage)}</td>
            <td>{item.type_id !== '' ? item.type_id : '-'}</td>
        </tr>
    );
};

export default TransactionReportTableRow;
